module.exports = __webpack_public_path__ + "img/defult_avatar.476abdcb.png";